// extracted by mini-css-extract-plugin
export default {"fitnessOutline":"GiftLandingPage_fitnessOutline__FYjpx","textTop":"GiftLandingPage_textTop__siIWm"};